"use client";

import { Button } from "@workspace/ui/components/button";
import { KeyboardShortcut } from "@workspace/ui/components/keyboard-shortcut";
import dynamic from "next/dynamic";
import * as React from "react";
import type { NewSaleDefaultPath } from "@/lib/constants/new-sale-default-path";

const AppCommandDialog = dynamic(
  () =>
    import("@/features/common/command-dialog").then(
      (mod) => mod.AppCommandDialog
    ),
  { ssr: false }
);

type CommandDialogTriggerProps = {
  permissions: string[];
  warehouseCount: number;
  defaultNewSalePath: NewSaleDefaultPath;
  isEnterpriseLegacyOrdersOrg?: boolean;
  accountingEnabled?: boolean;
  recurringInvoicingEnabled?: boolean;
};

export function CommandDialogTrigger({
  permissions,
  warehouseCount,
  defaultNewSalePath,
  isEnterpriseLegacyOrdersOrg = false,
  accountingEnabled = false,
  recurringInvoicingEnabled = false,
}: CommandDialogTriggerProps) {
  const [open, setOpen] = React.useState(false);

  React.useEffect(() => {
    const down = (e: KeyboardEvent) => {
      if (e.key === "k" && (e.metaKey || e.ctrlKey)) {
        e.preventDefault();
        setOpen((open) => !open);
      }
    };

    document.addEventListener("keydown", down);
    return () => document.removeEventListener("keydown", down);
  }, []);

  return (
    <>
      <Button
        className="hidden w-48 justify-between gap-2 text-muted-foreground md:flex"
        onClick={() => setOpen(true)}
        variant="outline"
      >
        Buscar...
        <KeyboardShortcut keyLabel="K" modifier="cmd" />
      </Button>
      <AppCommandDialog
        accountingEnabled={accountingEnabled}
        defaultNewSalePath={defaultNewSalePath}
        isEnterpriseLegacyOrdersOrg={isEnterpriseLegacyOrdersOrg}
        onOpenChange={setOpen}
        open={open}
        permissions={permissions}
        recurringInvoicingEnabled={recurringInvoicingEnabled}
        warehouseCount={warehouseCount}
      />
    </>
  );
}
